import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header";
import TabHeader from "../../components/TabHeader";
import LoaderImage from "../../images/ohhto-loading.gif";
import MenuIcon from "../../images/horizontal-icon.svg";
import ImageInput from "../../components/ImageInput";
import CropPopup from "../../components/CropPopup";
import CountryCode from "../../config/countryCode.json";
import Input from "../../components/Input";
import { useSelector } from "react-redux";
import axios from "../../helpers/axios";
import { dataURItoBlob } from "../../helpers/utils";
import {
  IMAGE_BASE_URL,
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LTV_LIST,
} from "../../helpers/constants";
import CustomSelect from "../../components/CustomSelect";
import { useParams } from "react-router-dom";
import AgentConfirmationPopup from "../../components/AgentConfirmationPopup";
import InfoTab from "./components/InfoTab";
import POC from "./components/SecondaryPOC";
import Moment from "moment";
import { toast } from "react-toastify";

export default function AgentInfo() {
  const { id } = useParams();
  const [showManageModal, setShowManageModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  // const [showFeatureModal,setShowFeatureModal] = useState(false)
  const [featureModal, setFeatureModal] = useState();
  const [banModal, setBanModal] = useState();
  const [rejectModal, setRejectModal] = useState();
  const [approveModal, setApproveModal] = useState();
  const [tabData, setTabData] = useState([
    { label: "Manage Agent", value: 1 },
    // { label: "Manage Loan Product", value: 0 },
  ]);
  const [activeTab, setActiveTab] = useState(1);
  const authInfo = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(true);

  const formRef = useRef(null);
  const ref = useRef(null);
  const dropRef = useRef(null);
  const [menuPopup, setMenuPopup] = useState(false);

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    passwordMatch: false,
    icon: "",
    uenNumber: null,
    faxNumber: null,
    countryCode: "",
    phoneNumber: null,
    featured: 0,
    status: 0,
    approvalTime: 1,
    ltv: 1,
    addressLine1: "",
    addressLine2: "",
    country: "",
    postalCode: null,
    contacts: [
      {
        name: "",
        email: "",
        isPrimary: 1,
        emailUpdate: 0,
        smsUpdate: 0,
        designation: "",
        countryCode: "",
        phoneNumber: null,
      },
    ],
  });
  async function getAgentInfo() {
    setLoading(true);
    let res = await axios.get(
      `/admin/agent/info/${id}`
    );
    setData(res.data.data);
    setLoading(false);
  }

  useEffect(() => {
    getAgentInfo();
  }, [activeTab]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      ref.current &&
      (!ref.current.contains(event.target) ||
        !dropRef.current.contains(event.target))
    ) {
      // setMenuPopup(false);
    }
  };

  const confirmFeatured = async () => {
    try {
      let res = await axios.put(`/admin/agent/update/${id}`, {
        ...data,
        featured: !data.featured,
      });
      setFeatureModal(false);
      setData((data) => ({ ...data, featured: !data.featured }));
      toast.success(res.data?.message);
    } catch (error) {
      toast.error(error);
    }
  };

  const confirmBan = async () => {
    try {
      let res = await axios.put(`/admin/agent/update/${id}`, {
        ...data,
        status: 3,
      });
      setData((data) => ({ ...data, status: 3 }));
      setBanModal(false);
      toast.success(res.data?.message);
    } catch (error) {
      toast.error(error);
    }
  };

  const confirmReject = async () => {
    try {
      let res = await axios.put(`/admin/agent/update/${id}`, {
        ...data,
        status: 2,
      });
      setData((data) => ({ ...data, status: 2 }));
      setRejectModal(false);
      toast.success(res.data?.message);
    } catch (error) {
      toast.error(error);
    }
  };

  const confirmApprove = async () => {
    try {
      let res = await axios.put(`/admin/agent/update/${id}`, {
        ...data,
        status: 1,
      });
      setData((data) => ({ ...data, status: 1 }));
      setApproveModal(false);
      toast.success(res.data?.message);
    } catch (error) {
      toast.error(error);
    }
  };

  const RightContent = () => {
    return !loading ? (
      <div className="relative">
        <div className="hidden md:flex justify-between w-full md:justify-end">
          {activeTab === 1 ? (
            viewMode ? (
              <div>
                {data.status !== 0 ? (
                  <button
                    className="btn-sm-disabled mr-1 md:mr-3 items-center align-middle"
                    onClick={() => setFeatureModal(true)}
                  >
                    {data.featured ? `Featured` : "Feature It"}{" "}
                    <div className="w-3 h-3 inline-block my-auto ml-2">
                      <svg
                        width="21"
                        className="w-full h-auto cursor-pointer"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M16.5186 19.9505C16.8292 20.1137 17.1923 19.85 17.1329 19.504L15.9832 12.793L20.8571 8.04214C21.1084 7.7972 20.9696 7.37023 20.6222 7.31991L13.8872 6.34496L10.8725 0.236076C10.717 -0.078692 10.2683 -0.078692 10.1129 0.236076L7.09543 6.34133L0.363145 7.31964C0.0157684 7.36997 -0.123016 7.79695 0.128309 8.04187L5.00353 12.7923L3.85257 19.5033C3.7932 19.8492 4.15635 20.113 4.46687 19.9497L10.4954 16.7803L16.5186 19.9505Z"
                          fill={data.featured ? "#FFA800" : "#d3d3d3"}
                        />
                      </svg>
                    </div>
                  </button>
                ) : null}
                <button
                  className="btn-sm-disabled mr-1 md:mr-3"
                  onClick={() => setViewMode(false)}
                >
                  Edit
                </button>
                {data.status !== 3 || data.status !== 0 ? (
                  <button
                    className="btn-sm-disabled mr-1 md:mr-3"
                    onClick={() => setBanModal(true)}
                  >
                    Ban
                  </button>
                ) : null}
                {data.status !== 2 ? (
                  <button
                    className="btn-sm-red mr-1 md:mr-3"
                    onClick={() => setRejectModal(true)}
                  >
                    Reject
                  </button>
                ) : null}
                {data.status !== 1 ? (
                  <button
                    className="btn-sm"
                    onClick={() => setApproveModal(true)}
                  >
                    Approve
                  </button>
                ) : null}
              </div>
            ) : (
              <div>
                <button
                  className="btn-sm-disabled mr-1 md:mr-3"
                  onClick={() => setViewMode(true)}
                >
                  Cancel
                </button>
                <button type="submit" form="edit-agent" className="btn-sm">
                  Save
                </button>
              </div>
            )
          ) : null}
        </div>
        <div>
          {viewMode ? (
            <div
              className="md:hidden mr-4"
              ref={ref}
              onClick={() => setMenuPopup(!menuPopup)}
            >
              <div className="flex justify-center w-5 h-5 items-center gap-2 rounded-md font-medium bg-white align-middle  transition-all">
                <img src={MenuIcon} className="w-full h-full md:w-10 md:h-10" />
              </div>
            </div>
          ) : (
            <div className="md:hidden">
              <button
                className="btn-sm-disabled mr-2 md:mr-3"
                onClick={() => setViewMode(true)}
              >
                Cancel
              </button>
              <button type="submit" form="edit-agent" className="btn-sm">
                Save
              </button>
            </div>
          )}
        </div>
        <div ref={dropRef}>
          {menuPopup && viewMode ? (
            <div className="absolute bg-white shadow-lg shadow-slate-200 border z-[99] border-gray-200 rounded-lg w-[90px] top-[38px] right-[10%] overflow-hidden">
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setViewMode(false)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-gray-700">
                  Edit
                </p>
              </div>
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setBanModal(true)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-gray-700">
                  Ban
                </p>
              </div>
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setRejectModal(true)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-gray-700">
                  Reject
                </p>
              </div>
              <div
                className="flex px-4  py-2 w-full hover:bg-slate-50 cursor-pointer"
                onClick={() => setApproveModal(true)}
              >
                <p className="text-sm md:text-xs font-medium  tracking-[-.25px] text-red-500">
                  Approve
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    ) : (
      <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
        <img src={LoaderImage} className="w-24 h-24" />
      </div>
    );
  };
  return (
    <div className="flex flex-col w-full h-full">
      <Header title={"Agent Accounts"} RightContent={RightContent} />
      <TabHeader data={tabData} active={activeTab} setActive={setActiveTab} />
      {/* <PrimaryHeader sort={sort} setSort={setSort} title={'Agents Accounts'} activeTab={activeTab} setActiveTab={setActiveTab} btnTitle={'Create New Agent'} tabData={tabData} setShowModal={setShowManageModal} searchText={searchText} setSearchText={setSearchText}/> */}
      <div className="flex-1 h-full w-full overflow-y-scroll">
        {!loading && activeTab === 1 ? (
          <ManageAgentForm
            setViewMode={setViewMode}
            formRef={formRef}
            id={id}
            updateData={data}
            viewMode={viewMode}
            getAgentInfo={getAgentInfo}
          />
        ) : (
          <div>No data..!</div>
        )}
      </div>
      {featureModal ? (
        <AgentConfirmationPopup
          type={"feature"}
          onClose={() => setFeatureModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmFeatured}
        />
      ) : null}
      {banModal ? (
        <AgentConfirmationPopup
          type={"ban"}
          onClose={() => setBanModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmBan}
        />
      ) : null}
      {rejectModal ? (
        <AgentConfirmationPopup
          type={"reject"}
          onClose={() => setRejectModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmReject}
        />
      ) : null}
      {approveModal ? (
        <AgentConfirmationPopup
          type={"approve"}
          onClose={() => setApproveModal(false)}
          setActiveData={setData}
          activeData={data}
          onConfirm={confirmApprove}
        />
      ) : null}
    </div>
  );
}

const ManageAgentForm = ({
  updateData,
  setActive,
  viewMode,
  update = false,
  id,
  formRef,
  setViewMode,
  getAgentInfo,
}) => {
  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState();
  const settings = useSelector((state) => state.settings);
  const [errors, setErrors] = useState();
  const [activeTab, setActiveTab] = useState("in-house");
  //console.log("updateData", updateData);
  const [createData, setCreateData] = useState(updateData);
  const [editPassword, setEditPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
      setCreateData((data) => ({ ...data, icon: "" }));
    }
  };

  const onPOCAdd = (initial) => {
    setCreateData((data) => ({
      ...data,
      contacts: [
        ...data.contacts,
        {
          name: "",
          email: "",
          isPrimary: initial ? 1 : 0,
          emailNotification: 0,
          smsNotification: 0,
          designation: "",
          countryCode: "+65",
          phoneNumber: null,
        },
      ],
    }));
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setEditPassword(false);
      setErrors(false);
      if (editPassword && createData.password !== createData.confirmPassword) {
        setErrors((data) => ({
          ...data,
          confirmPassword: "Password does not match",
        }));
        return false;
      }
      if (!croppedImage && !createData.icon) {
        setErrors((data) => ({ ...data, icon: "Please upload the logo" }));
        return false;
      }
      setLoading(true);
      let blobFile = await dataURItoBlob(croppedImage);
      let formData = new FormData();
      formData.append("file", blobFile, "crop-icon.jpg");
      formData.append("module", "agent");

      let fileRes = await axios.post("/admin/upload/image", formData);
      let res = await axios.put(`/admin/agent/update/${id}`, {
        ...createData,
        icon: createData.icon ? createData.icon : fileRes.data.data,
        password: editPassword ? createData.password : null,
      });
      if (res.status < 400) {
        setViewMode(true);
        toast.success(res.data?.message);
        getAgentInfo();
      }
    } catch (error) {
      Object.keys(error.response.data.errors).forEach(function (key) {
        toast.error(
          error.response.data.errors[key] !== undefined
            ? error.response.data.errors[key]
            : "Error occured profile not updated..!"
        );
      });
    }
  };

  // const onCrate
  return (
    <>
      <div className="py-4 px-4 md:py-8 md:px-9 w-full bg-white">
        <form id="edit-agent" className="w-full max-w-xl" onSubmit={onSubmit}>
          <div className="grid grid-cols-1 gap-x-3 gap-y-1 md:gap-y-4">
            {viewMode ? (
              <div className="userInfo">
                <div className="grid grid-cols-8 gap-x-3">
                  <div className="col-span-4">
                    <label>Created On</label>
                    <p class="md:text-sm text-black ">
                      {Moment(createData.created_at).format(
                        "DD-MM-YYYY HH:MM"
                      )}
                    </p>
                  </div>
                  <div className="col-span-4">
                    <label>Updated On</label>
                    <p class="md:text-sm text-black ">
                      {Moment(createData.updated_at).format(
                        "DD-MM-YYYY HH:MM"
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-span-2  md:mt-3">
                  <label>Agent Status</label>
                  <p class="md:text-sm text-black ">
                    {createData.status == 0
                      ? "Pending"
                      : createData.status == 1
                      ? "Approved"
                      : createData.status == 2
                      ? "Rejected"
                      : createData.status == 3
                      ? "Banned"
                      : ""}
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="col-span-1">
              <label>Agent Email</label>
              <Input
                type="email"
                required={true}
                viewMode={viewMode}
                value={createData.email}
                placeholder={"Enter Email address"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, email: value }))
                }
                error={errors ? errors["email"] : null}
              />
            </div>
            <div className="col-span-1">
              <div className="flex justify-between">
                <label>Password</label>{" "}
                {editPassword || viewMode ? null : (
                  <p
                    className="text-xs text-blue-600 font-medium tracking-tight cursor-pointer"
                    onClick={() => setEditPassword(!editPassword)}
                  >
                    Set Password
                  </p>
                )}
              </div>
              <Input
                type="password"
                value={createData.password}
                disabled={viewMode || !editPassword}
                required={editPassword}
                viewMode={viewMode}
                placeholder={"Enter Password"}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, password: value }))
                }
                error={errors?.password}
              />
            </div>
            <div className="col-span-1">
              {viewMode || !editPassword ? null : (
                <>
                  <label>Confirm Password</label>
                  <Input
                    type="password"
                    value={createData.confirmPassword}
                    disabled={viewMode || !editPassword}
                    required={editPassword}
                    viewMode={viewMode}
                    placeholder={"Confirm Password"}
                    setValue={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        confirmPassword: value,
                      }))
                    }
                    error={errors?.confirmPassword}
                  />
                </>
              )}
            </div>
          </div>
          <div className="mt-5">
            <p className="text-sm tracking-tight font-semibold mt-5 mb-7">
              Agent Details
            </p>
            <div className="grid grid-cols-3 mt-2 gap-x-3 gap-y-1 md:gap-y-4">
              <div className="col-span-3 grid grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-1 md:gap-y-0">
                <div className={`col-span-3 ${viewMode ? "mb-3" : ""}`}>
                  <label>Agent&apos;s Logo</label>
                  {viewMode ? (
                    <img
                      src={
                        createData.icon
                          ? `${IMAGE_BASE_URL}/${createData.icon}`
                          : croppedImage
                      }
                      className="h-7 w-7 rounded-md"
                    />
                  ) : (
                    <ImageInput
                      viewMode={viewMode}
                      image={
                        createData.icon && createData.icon !== ""
                          ? `${IMAGE_BASE_URL}/${createData.icon}`
                          : croppedImage
                      }
                      setImage={onImageChange}
                      error={errors ? errors["icon"] : null}
                    />
                  )}
                </div>
              </div>
              <div className="col-span-2">
                <label>Agent Company Name</label>
                <Input
                  value={createData.name}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Enter Company Name"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, name: value }))
                  }
                />
              </div>
              <div className="col-span-1">
                <label>UEN Number</label>
                <Input
                  value={createData.uenNumber}
                  number={true}
                  type="text"
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Enter UEN Number"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, uenNumber: value }))
                  }
                />
              </div>
              <div className="col-span-3 md:col-span-2 gap-x-2">
                <div className="flex flex-wrap gap-[12px]">
                  <div className="w-[100px]">
                    <label>Country Code*</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.countryCode}
                      </p>
                    ) : (
                      <CustomSelect
                        customLabel={"dial_code"}
                        customValue={"dial_code"}
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select"}
                        options={CountryCode}
                        value={createData.countryCode}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            countryCode: value,
                          }))
                        }
                      />
                    )}
                  </div>
                  <div className="flex-[1]">
                    <label>Contact Number</label>
                    <Input
                      number={true}
                      type="text"
                      value={createData.phoneNumber}
                      required={true}
                      viewMode={viewMode}
                      placeholder={"Contact Number"}
                      setValue={(value) =>
                        setCreateData((data) => ({
                          ...data,
                          phoneNumber: value,
                        }))
                      }
                      maxLength={8}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-3 md:col-span-1">
                <label>Fax Number</label>
                <Input
                  number={true}
                  type="text"
                  value={createData.faxNumber}
                  viewMode={viewMode}
                  placeholder={"Fax Number"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, faxNumber: value }))
                  }
                />
              </div>
            </div>
            <div className=" md:mt-3">
              <div>
                <label>{viewMode ? "Address Line 1" : "Address"}</label>
                <Input
                  type="text"
                  value={createData.addressLine1}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 1 ( Floor, Unit No., Street Name)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, addressLine1: value }))
                  }
                />
              </div>
            </div>
            <div className="md:mt-3">
              <div>
                {viewMode ? <label>Address Line 2</label> : null}
                <Input
                  type="text"
                  value={createData.addressLine2}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Address 2 (Building name, other info)"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, addressLine2: value }))
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 md:mt-3">
              <div>
                {viewMode ? <label>Postal Code</label> : null}
                <Input
                  number={true}
                  type="text"
                  value={createData.postalCode}
                  required={true}
                  viewMode={viewMode}
                  placeholder={"Postal Code"}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, postalCode: value }))
                  }
                />
              </div>
              <div>
                {viewMode ? <label>Country</label> : null}
                <CustomSelect
                  required={true}
                  disabled={viewMode}
                  placeholder={"Select Country"}
                  customValue={"code"}
                  options={CountryCode}
                  value={createData.country}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, country: value }))
                  }
                  error={errors ? errors["country"] : null}
                />
              </div>
            </div>
            <div className="mt-5">
              <p className="text-sm tracking-tight font-semibold">Ratings</p>
              <InfoTab activeTab={activeTab} setActiveTab={setActiveTab} />
              {activeTab === "in-house" ? (
                <div className="columns-[200px] gap-[15px] mt-[20px]">
                  <div className="md:inline-block">
                    <label>Approval Time</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.approvaltimeinfo?.name}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Approval Time"}
                        options={settings[SETTINGS_APPROVAL_TIME_LIST]}
                        value={createData.approvalTime}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            approvalTime: value,
                          }))
                        }
                        error={errors ? errors["approvalTime"] : null}
                      />
                    )}
                  </div>
                  <div className="">
                    <label>Loan To Value</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.ltvinfo?.name}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Loan to Value"}
                        options={settings[SETTINGS_LTV_LIST]}
                        value={createData.ltv}
                        setValue={(value) =>
                          setCreateData((data) => ({ ...data, ltv: value }))
                        }
                        error={errors ? errors["ltv"] : null}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="columns-[200px] gap-[15px] mt-[20px]">
                  <div className="md:inline-block">
                    <label>Approval Time</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.floor_approvaltimeinfo?.name !== undefined
                          ? createData.floor_approvaltimeinfo?.name
                          : "--"}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Approval Time"}
                        options={settings[SETTINGS_APPROVAL_TIME_LIST]}
                        value={createData.floor_approvalTime}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            floor_approvalTime: value,
                          }))
                        }
                        error={errors ? errors["floor_approvalTime"] : null}
                      />
                    )}
                  </div>
                  <div className="">
                    <label>Loan To Value</label>
                    {viewMode ? (
                      <p className="text-sm text-black">
                        {createData.floor_ltvinfo?.name !== undefined
                          ? createData.floor_ltvinfo?.name
                          : "--"}
                      </p>
                    ) : (
                      <CustomSelect
                        required={true}
                        disabled={viewMode}
                        placeholder={"Select Loan to Value"}
                        options={settings[SETTINGS_LTV_LIST]}
                        value={createData.floor_ltv}
                        setValue={(value) =>
                          setCreateData((data) => ({
                            ...data,
                            floor_ltv: value,
                          }))
                        }
                        error={errors ? errors["floor_ltv"] : null}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="mt-5">
              <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                Contacts
              </h4>
              <div>
                <InHouseTab
                  viewMode={viewMode}
                  onPOCAdd={onPOCAdd}
                  createData={createData}
                  setCreateData={setCreateData}
                />
              </div>
            </div>
            <div className="mt-5">
              {!viewMode ? (
                <div className="flex justify-start">
                  <button
                    className="btn-sm-disabled mr-1 md:mr-3"
                    onClick={() => {
                      setErrors(false);
                      setEditPassword(false);
                      setCreateData(updateData);
                      setViewMode(true);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="btn-sm" type="submit">
                    Save
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </form>
      </div>
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={setCroppedImage}
        />
      ) : null}
    </>
  );
};

const InHouseTab = ({ createData, setCreateData, onPOCAdd, viewMode }) => {
  return (
    <div>
      <div className="block justify-between items-center">
        {createData.contacts.map((item, index) => {
          return (
            <POC
              viewMode={viewMode}
              index={index}
              createData={createData}
              setCreateData={setCreateData}
            />
          );
        })}
      </div>
      {!viewMode ? (
        <div className="mt-5">
          <button
            type="button"
            className="btn-sm-disabled"
            onClick={() => {
              //console.log("CONTACTSLENGTH", createData.contacts?.length);
              onPOCAdd(createData.contacts?.length == 0 ? true : false);
            }}
          >
            Add Another Point of Contact (Max 10)
          </button>
        </div>
      ) : null}
    </div>
  );
};
